import { createNewModel } from '@/components/RouteComponents/commonFunctions'

export const arSystemViewMixins = {
  methods: {
    /**
     * Submits the form, deleting any property listed in this.hiddenFields beforehand
     */
    // submitForm () {
    //   if (this.hiddenFields && this.hiddenFields.length) {
    //     this.hiddenFields.forEach(field => {
    //       if (this.form.hasOwnProperty(field)) delete this.form[field]
    //     })
    //   }
    //   submitFormBasic(this, this.payload)
    // },
    /**
     * Resets editMode data, resets form to initial state, and displays the
     * modal to create a new model
     */
    createNewModel () {
      createNewModel(this)
      this.setDefaultMarkupType()
    },
    /**
     * Display the amount_decimal or rate input form fields depending on the value of markup_type
     */
    displayAmountOrPercentageFields () {
      const { form, markupTypeFieldName, defaultMarkupPrefix } = this
      if (form && form.hasOwnProperty(markupTypeFieldName)) {
        const { value } = this.form[markupTypeFieldName]
        this.hiddenFields = ['created_on']
        if (value === 'AMT') {
          this.hiddenFields.push(`${defaultMarkupPrefix}rate`)
          this.hiddenFields = this.hiddenFields.filter(field => field !== `${defaultMarkupPrefix}amount_decimal`)
          this.fields = { field: markupTypeFieldName, property: 'required', newValue: false }
        } else if (value === 'PCT') {
          this.hiddenFields.push(`${defaultMarkupPrefix}amount_decimal`)
          this.hiddenFields = this.hiddenFields.filter(field => field !== `${defaultMarkupPrefix}rate`)
          this.fields = { field: markupTypeFieldName, property: 'required', newValue: false }
        } else if (value === null || value === 'NON') {
          this.hiddenFields.push(`${defaultMarkupPrefix}amount_decimal`)
          this.hiddenFields.push(`${defaultMarkupPrefix}rate`)
          this.fields = { field: markupTypeFieldName, property: 'required', newValue: true }
        } else {
          this.hiddenFields = ['created_on']
          this.fields = { field: markupTypeFieldName, property: 'required', newValue: false }
        }
      }
    },
    /**
     * Sets the default markup type
     */
    setDefaultMarkupType () {
      this.hiddenFields.push(`${this.defaultMarkupPrefix}amount_decimal`)
      this.hiddenFields.push(`${this.defaultMarkupPrefix}rate`)
      const { form, fieldChoices, markupTypeFieldName } = this
      if (form && fieldChoices && form.hasOwnProperty(markupTypeFieldName)) {
        if (fieldChoices[markupTypeFieldName] && fieldChoices[markupTypeFieldName]['NON']) {
          let tmp = Object.assign({}, this.form)
          tmp[markupTypeFieldName] = Object.assign({}, { label: 'Not Set', value: 'NON' })
          this.form = Object.assign({}, tmp)
        }
      }
    }
  },
  computed: {
    /**
     * Returns the name of the markup_type field, since the API sometimes uses 'default_markup_type' and other times
     * just uses 'markup_type'
     * @return {*}
     */
    markupTypeFieldName () {
      if (this.form && this.form.hasOwnProperty('default_markup_type')) {
        return 'default_markup_type'
      } else if (this.form && this.form.hasOwnProperty('markup_type')) {
        return 'markup_type'
      }
      return ''
    },
    /**
     * Returns the name of the amount_decimal or rate field for markups, since the API sometimes prefixes these fields
     * with 'default_markup' and other times does not
     * @return {*}
     */
    defaultMarkupPrefix () {
      return this.markupTypeFieldName.includes('default') ? 'default_markup_' : ''
    }
  }
}
